import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { UserService } from '../services/user.service';
import { BFF_ERROR_CODES } from '@core/constants/bff-error-messages';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private userService: UserService,
    private location: Location
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        error: (err) => {
          if (err.status !== HttpStatusCode.Forbidden) return;

          switch (err.error?.code) {
            case BFF_ERROR_CODES.INVALID_USER_STATE:
              this.refreshApplication();
              break;
            default:
              break;
          }
        },
      })
    );
  }

  private refreshApplication() {
    this.router.navigate(['']);
    this.location.reload();
  }
}
